module.exports = __webpack_public_path__ + "img/logo2.d9386318.png";